import { admin2 } from './instance'
import { isBenefitSharingEnabled } from '@/use/useOrgBenefitControl'

export const GetCouponConfig = async ({
  shopId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponConfig`,
  })
}

export const UpdateCouponConfig = async ({
  shopId,
  displayName,
  expireNotificationBefore,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/couponConfig`,
    data: {
      displayName,
      expireNotificationBefore,
    },
  })
}

/**
 * 取得兌換券列表
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {number} [params.start=0] - 查詢起始
 * @param {number} [params.limit=100] - 查詢筆數
 * @param {boolean} [params.crossShop] - 是否查詢跨店共用資料
 * @param {string} [params.benefitShopScope] - 適用類型篩選（local/all/shared），優先於 crossShop
 * @param {string} [params.issuingShopId] - 發行店篩選
 * @returns {Promise<Array>} 兌換券列表
 */
export const GetCouponExchange = async ({
  shopId,
  start,
  limit,
  crossShop,
  benefitShopScope,
  issuingShopId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponExchange`,
    params: {
      start,
      limit,
      benefitShopScope: benefitShopScope || (crossShop == null ? (isBenefitSharingEnabled('coupon', shopId) ? 'all' : undefined) : (crossShop ? 'all' : 'local')),
      issuingShopId,
    },
  })
}

export const FindCouponExchange = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponExchange/${id}`,
  })
}

/**
 * 取得兌換券總數
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {boolean} [params.crossShop] - 是否查詢跨店共用資料
 * @param {string} [params.benefitShopScope] - 適用類型篩選（local/all/shared），優先於 crossShop
 * @param {string} [params.issuingShopId] - 發行店篩選
 * @returns {Promise<Object>} 兌換券總數
 */
export const GetCouponExchangeCount = async ({
  shopId,
  crossShop,
  benefitShopScope,
  issuingShopId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponExchange/count`,
    params: {
      benefitShopScope: benefitShopScope || (crossShop == null ? (isBenefitSharingEnabled('coupon', shopId) ? 'all' : undefined) : (crossShop ? 'all' : 'local')),
      issuingShopId,
    },
  })
}

export const CreateCouponExchange = async ({
  shopId,
  image,
  name,
  expType,
  expDay,
  expAt,
  notice,
  showMinute,
  systemRedeem,
  endOfPeriodUnit,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/couponExchange`,
    data: {
      name,
      image,
      expType,
      expDay,
      expAt,
      notice,
      showMinute,
      systemRedeem,
      endOfPeriodUnit,
    },
  })
}

export const UpdateCouponExchange = async ({
  shopId,
  id,
  name,
  image,
  expType,
  expDay,
  expAt,
  notice,
  showMinute,
  exchangeType,
  exchangeLink,
  systemRedeem,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/couponExchange/${id}`,
    data: {
      name,
      image,
      expType,
      expDay,
      expAt,
      notice,
      showMinute,
      exchangeType,
      exchangeLink,
      systemRedeem,
    },
  })
}

export const DeleteCouponExchange = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'DELETE',
    url: `/${shopId}/couponExchange/${id}`,
  })
}

export const CreateCouponExchangeSerial = async ({
  shopId,
  CouponId,
  source,
  serials,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/couponExchangeSerial`,
    data: {
      CouponId,
      source,
      serials,
    },
  })
}

export const CreateSystemCouponExchangeSerial = async ({
  shopId,
  CouponId,
  amount,
  generators,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/couponExchangeSerial/systemCreate`,
    data: {
      CouponId,
      amount,
      generators,
    },
  })
}

export const GetCouponExchangeSerial = async ({
  shopId,
  CouponId,
  start,
  limit,
  code,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponExchangeSerial`,
    params: {
      CouponId,
      start,
      limit,
      code,
    },
  })
}

export const GetCouponExchangeSerialCount = async ({
  shopId,
  CouponId,
  code,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponExchangeSerial/count`,
    params: {
      CouponId,
      code,
    },
  })
}

export const UpdateCouponExchangeSerial = async ({
  shopId,
  id,
  code,
  totalStock,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/couponExchangeSerial/${id}`,
    data: {
      code,
      totalStock,
    },
  })
}

export const DeleteCouponExchangeSerial = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'DELETE',
    url: `/${shopId}/couponExchangeSerial/${id}`,
  })
}

export const GetCouponRecordTypeOptions = async ({
  shopId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponRecord/typeOptions`,
  })
}

/**
 * 取得票券紀錄建立前檢查 admin.couponRecord.createCheck
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.couponId - 票券ID
 * @typedef {Object} createCheckResult - 檢查結果
 * @property {string} code - 警告代碼
 * @property {string} message - 警告訊息
 * @property {string} couponId - 票券ID
 * @property {string} couponName - 票券名稱
 * @returns {Promise<[{ warnings: createCheckResult[] }, err, rawErr]>} 檢查結果
 * @example
 * // 回傳格式
 * {
 *   warnings: [{
 *     code: 'COUPON_NOTIFICATION_DISABLED',
 *     message: '未開啟 LINE 訊息通知',
 *     couponId: 'xxx',
 *     couponName: 'xxx'
 *   }]
 * }
 */
export const GetCouponRecordCreateCheck = async ({
  shopId,
  couponId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponRecord/createCheck`,
    params: {
      couponId,
    },
  })
}
